import { Config as ConfigIcon, Forms as FormsIcon } from '@clearkit/icons';
import { CKTab, CKTabList, CKTabs } from 'clearkit';
import { useHistory } from 'react-router-dom';

import ConnectorLayout from '~/components/layouts/ConnectorLayout';
import { PAGES } from '~/constants/pages';
import { FREE_TIER } from '~/constants/plans';
import { AccountFlagEnum } from '~/generated/graphql';
import { useFeatureFlag } from '~/hooks/account';
import Tile from '~/images/Tiles/Forms.svg';
import { configurationNameForType } from '~/lib/configuration';
import { connectorLocations } from '~/lib/segmentAnalytics';

import Configuration from './Configuration';
import Mappings from './Mappings';

const TABS = [
  {
    key: 'configuration',
    title: 'Configuration',
    icon: ConfigIcon,
    component: Configuration,
    index: 0,
  },
  {
    key: 'mappings',
    title: 'Form Field Mappings',
    icon: FormsIcon,
    component: Mappings,
    index: 1,
  },
];

function FormConfiguration({ integration, selectedTab }) {
  const currentTab = selectedTab || 'configuration';

  const currentTabObject = TABS.find((t) => t.key === currentTab);
  const FormComponent = currentTabObject.component;
  const history = useHistory();

  const hasFreemiumConnectionsUI = useFeatureFlag(
    AccountFlagEnum.RolloutPlatformFreemiumConnectionsUi,
  ).enabled;

  const breadcrumbProps = hasFreemiumConnectionsUI
    ? FREE_TIER.PAGES.ENRICHMENT.CONFIGURATION
    : PAGES.ENRICHMENT.CONFIGURATION;
  const title = hasFreemiumConnectionsUI
    ? `${configurationNameForType(integration)} Forms`
    : configurationNameForType(integration);
  return (
    <ConnectorLayout
      breadcrumb={[
        {
          title: breadcrumbProps.TITLE,
          path: breadcrumbProps.PATH,
        },
      ]}
      connectorLocation={connectorLocations.forms}
      integration={integration}
      subtitle={`Improve conversion rates on ${configurationNameForType(
        integration,
      )} forms`}
      tabs={
        <CKTabs
          className="h-full"
          index={currentTabObject.index}
          isBordered
          onChange={(index) => {
            const newTab = TABS[index];

            history.push(`/forms/${integration}/${newTab.key}`);
          }}
        >
          <CKTabList aria-label="Forms Configuration Tabs">
            {Object.values(TABS).map((tab) => (
              <CKTab icon={<tab.icon />} key={tab.key} label={tab.title}>
                {tab.title}
              </CKTab>
            ))}
          </CKTabList>
        </CKTabs>
      }
      tile={<Tile />}
      title={title}
    >
      {() => (
        <div className="h-full px-10 py-10 bg-gray-50">
          <FormComponent integration={integration} />
        </div>
      )}
    </ConnectorLayout>
  );
}

FormConfiguration.propTypes = {
  integration: PropTypes.string.isRequired,
  selectedTab: PropTypes.string,
};

export default FormConfiguration;
